// react
import { forwardRef } from "react";
// framer
import { m } from "framer-motion";
// @mui
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
// types
import type { FC, PropsWithChildren } from "react";
import type { IconButtonProps } from "@mui/material";

interface IconButtonAnimateProps extends Omit<IconButtonProps, "ref"> {}

export const IconButtonAnimate: FC<PropsWithChildren<IconButtonAnimateProps>> =
  forwardRef<HTMLButtonElement, IconButtonAnimateProps>((props, ref: any) => {
    const { size, children, sx, ...otherProps } = props;

    return (
      <AnimateWrap size={size}>
        <IconButton ref={ref} {...otherProps}>
          {children}
        </IconButton>
      </AnimateWrap>
    );
  });

// ----------------------------------------------------------------------

const varSmall = {
  hover: { scale: 1.1 },
  tap: { scale: 0.95 },
};

const varMedium = {
  hover: { scale: 1.09 },
  tap: { scale: 0.97 },
};

const varLarge = {
  hover: { scale: 1.08 },
  tap: { scale: 0.99 },
};

interface AnimateWrapProps {
  size: IconButtonAnimateProps["size"];
}

const AnimateWrap: FC<PropsWithChildren<AnimateWrapProps>> = (props) => {
  const { size, children } = props;

  const isSmall = size === "small";
  const isLarge = size === "large";

  return (
    <Box
      component={m.div}
      whileTap="tap"
      whileHover="hover"
      variants={(isSmall && varSmall) || (isLarge && varLarge) || varMedium}
      style={{
        display: "inline-flex",
      }}
    >
      {children}
    </Box>
  );
};
